import { useContext, useMemo } from 'react';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { useSchoolShift } from '../hooks/useSchoolShift';
import { buildDarkTheme } from './Constants';
import SchoolShiftDeleteModal from './SchoolShiftDeleteModal';
import SchoolShiftEditor from './SchoolShiftEditor';
import SchoolShiftSidebar from './SchoolShiftSidebar';
import { AppContext } from '../../../context/AppContextProvider';

const SchoolShiftList = () => {
  const { state, actions, form } = useSchoolShift();
  const { theme: appThemeName } = useContext(AppContext);
  const darkTheme = useMemo(() => buildDarkTheme(appThemeName), [appThemeName]);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box 
        sx={{ 
          display: 'flex', 
          height: '100vh', 
          bgcolor: 'background.default', 
          p: { xs: 1, md: 2 }, 
          gap: { xs: 1, md: 2 } 
        }}
      >
        <SchoolShiftSidebar state={state} actions={actions} />
        <SchoolShiftEditor state={state} actions={actions} form={form} />
      </Box>
      <SchoolShiftDeleteModal state={state} actions={actions} />
    </ThemeProvider>
  );
};

export default SchoolShiftList;